import { useGetUsersMeQuery } from '../api/user/queries/useGetUsersMe.query';
import { useCheckAppVersion } from '../check/useCheckAppVersion';
import { useCheckGlobalTooltip } from '../check/useCheckGlobalTooltip';
import { useCheckUserEnvironment } from '../check/useCheckUserEnvironment';
import { useStorePageToRedirection } from '../page/useStorePageToRedirection';
import { useScalable } from '../screen/useScalable';
import { useRestoreScrollY } from '../store/scrollY/useRestoreScrollY';
import { useStoreScrollY } from '../store/scrollY/useStoreScrollY';
import { useAmplitude } from '../third-party/amplitude/useAmplitude';
import { useCatchQueryString } from '../third-party/amplitude/useCatchQueryString';
import { useChannelTalk } from '../third-party/channelTalk/useChannelTalk';
import { useGA } from '../third-party/ga/useGA';
import { useHotjar } from '../third-party/hotjar/useHotjar';
import { RouterIFDOTracker } from '../third-party/ifdo/RouterIFDOTracker';

export const useAppSetup = () => {
  RouterIFDOTracker();
  useGetUsersMeQuery();
  useAmplitude();
  useGA();
  useHotjar();
  useStoreScrollY();
  useRestoreScrollY();
  useCheckUserEnvironment();
  useCheckAppVersion();
  useCatchQueryString();
  useScalable();
  useChannelTalk();
  useCheckGlobalTooltip();
  useStorePageToRedirection();
};
